const INVGATE_POST = "INVGATE_POST";

export default function incident(invgateDescription) {
  return {
    type: INVGATE_POST,
    payload: {
      request: {
        url: "Invgate",
        method: "POST",
        data: invgateDescription,
      },
    },
  };
}
